module.exports = __webpack_public_path__ + "images/backgrounds/ocean/medium.cd827f614a24c8551b05.jpg";